if (!customElements.get('mn-product-buybox')) {
  customElements.define('mn-product-buybox', class MnProductBuybox extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.baseChoice = this.querySelector('[data-buybox-choice][value="base"]');
      this.bundleChoice = this.querySelector('[data-buybox-choice][value="bundle"]');
      this.languageSelect = this.querySelector('[data-bundle-language]');
      this.bundleVariants = this.readJson('[data-bundle-variants]');
      this.ebookVariants = this.readJson('[data-ebook-variants]');
      this.originalPriceMarkup = this.getPriceList()?.outerHTML || '';

      if (!this.form || !this.baseChoice || !this.bundleChoice || !this.bundleVariants.length) return;

      this.variantInput = this.form.querySelector('input[name="id"]');
      this.choiceHandler = (event) => {
        if (!event.target.matches('[data-buybox-choice]')) return;
        this.updateSelection();
      };
      this.languageHandler = () => this.updateSelection();
      this.variantHandler = (event) => this.handleBaseVariantChange(event);

      this.addEventListener('change', this.choiceHandler);
      this.languageSelect?.addEventListener('change', this.languageHandler);
      this.form.addEventListener('variant:change', this.variantHandler);

      this.updateSelection();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.choiceHandler);
      this.languageSelect?.removeEventListener('change', this.languageHandler);
      this.form?.removeEventListener('variant:change', this.variantHandler);
    }

    readJson(selector) {
      try {
        return JSON.parse(this.querySelector(selector)?.textContent || '[]');
      } catch (_) {
        return [];
      }
    }

    get selectedBundleVariant() {
      const availableVariant = this.bundleVariants.find((variant) => variant.available) || this.bundleVariants[0];
      const selectedId = Number(this.languageSelect?.value || availableVariant.id);

      return this.bundleVariants.find((variant) => Number(variant.id) === selectedId) || availableVariant;
    }

    getPriceList() {
      return this.closest('.product-info')?.querySelector('[data-block-type="price"] price-list');
    }

    formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'EUR';
  const locale = document.documentElement.lang || 'de-DE';

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(Number(cents || 0) / 100);

  return currency === 'EUR'
    ? '€' + formatted.replace('€', '').trim()
    : formatted;
}

    matchingEbookPrice(bundleVariant) {
      if (!this.ebookVariants.length) return 0;

      const normalizedBundleOption = this.languageKey(bundleVariant.option1 || bundleVariant.title);
      const matchingVariant = this.ebookVariants.find((variant) => {
        const normalizedEbookOption = this.languageKey(variant.option1 || variant.title);
        return normalizedEbookOption === normalizedBundleOption;
      });

      return Number((matchingVariant || this.ebookVariants[0]).price || 0);
    }

    languageKey(value) {
      const normalizedValue = String(value || '').trim().toLowerCase();

      if (/deutsch|german|\bdeu\b|\bde\b/.test(normalizedValue)) return 'de';
      if (/english|englisch|\beng\b|\ben\b/.test(normalizedValue)) return 'en';

      return normalizedValue;
    }

    regularBundlePrice(bundleVariant) {
      const manualSaving = Number(this.dataset.manualSaving || 0);

      if (manualSaving > 0) return Number(bundleVariant.price) + manualSaving;

      const ebookPrice = this.matchingEbookPrice(bundleVariant);

      if (ebookPrice > 0) return Number(this.dataset.basePrice || 0) + ebookPrice;
      if (Number(bundleVariant.compareAtPrice || 0) > Number(bundleVariant.price)) {
        return Number(bundleVariant.compareAtPrice);
      }

      return 0;
    }

    updateOptionPrices(bundleVariant) {
      const bundlePrice = this.querySelector('[data-bundle-option-price]');
      const comparePrice = this.querySelector('[data-bundle-compare-price]');
      const savingBadge = this.querySelector('[data-bundle-saving]');
      const regularPrice = this.regularBundlePrice(bundleVariant);
      const saving = Math.max(0, regularPrice - Number(bundleVariant.price));
      const savingPercent = regularPrice > 0 ? Math.round((saving / regularPrice) * 100) : 0;
      const savingDisplay = this.dataset.savingDisplay || 'percent';

      if (bundlePrice) bundlePrice.textContent = this.formatMoney(bundleVariant.price);

      if (comparePrice) {
        comparePrice.textContent = this.formatMoney(regularPrice);
        comparePrice.hidden = this.dataset.showCompare !== 'true' || regularPrice <= Number(bundleVariant.price);
      }

      if (savingBadge) {
        savingBadge.textContent = savingDisplay === 'amount'
          ? `Spare ${this.formatMoney(saving)}`
          : `−${savingPercent}%`;
        savingBadge.hidden = savingDisplay === 'hidden' || saving <= 0;
      }
    }

    updateMainPrice(showBundle, bundleVariant) {
      const currentPriceList = this.getPriceList();
      if (!currentPriceList) return;

      const template = document.createElement('template');

      if (showBundle) {
        const bundleTemplate = this.querySelector(`[data-price-template="${bundleVariant.id}"]`);
        if (!bundleTemplate) return;
        template.innerHTML = bundleTemplate.innerHTML.trim();
      } else {
        template.innerHTML = this.originalPriceMarkup;
      }

      const replacement = template.content.firstElementChild;
      if (replacement) currentPriceList.replaceWith(replacement);
    }

    updateSelection() {
      const bundleSelected = this.bundleChoice.checked;
      const bundleVariant = this.selectedBundleVariant;
      const selectedVariantId = bundleSelected ? bundleVariant.id : this.dataset.baseVariantId;

      this.form = document.getElementById(this.dataset.formId) || this.form;
      this.variantInput = this.form?.querySelector('input[name="id"]') || this.variantInput;

      if (this.variantInput) this.variantInput.value = selectedVariantId;

      this.bundleChoice.dataset.variantId = bundleVariant.id;
      this.dataset.choice = bundleSelected ? 'bundle' : 'base';

      const details = this.querySelector('[data-buybox-details]');
      if (details) {
        details.hidden = !bundleSelected;
        details.setAttribute('aria-hidden', String(!bundleSelected));
      }
      this.bundleChoice.setAttribute('aria-expanded', String(bundleSelected));

      this.updateOptionPrices(bundleVariant);
      this.updateMainPrice(bundleSelected, bundleVariant);
    }

    handleBaseVariantChange(event) {
      if (!event.detail?.variant?.id || this.bundleChoice.checked) return;

      this.dataset.baseVariantId = event.detail.variant.id;
      this.dataset.basePrice = event.detail.variant.price;
      this.baseChoice.dataset.variantId = event.detail.variant.id;

      const basePrice = this.querySelector('[data-base-option-price]');
      if (basePrice) basePrice.textContent = this.formatMoney(event.detail.variant.price);

      requestAnimationFrame(() => {
        this.form = document.getElementById(this.dataset.formId) || this.form;
        this.variantInput = this.form?.querySelector('input[name="id"]') || this.variantInput;
        this.originalPriceMarkup = this.getPriceList()?.outerHTML || this.originalPriceMarkup;
        this.updateSelection();
      });
    }
  });
}
